export const MOCK_NAVIGATION_MAIN_LINKS = [
    {
        label: 'Wegenwacht',
        reference: 'wegenwacht',
        href: '/wegenwacht',
        subItems: {
            title: 'Wegenwacht',
            showAll: {
                label: 'Bekijk alles',
                href: '/wegenwacht',
            },
            group1: [
                [
                    {
                        label: 'Pechhulp auto',
                        reference: 'pechhulp-auto',
                        href: '/wegenwacht',
                    },
                    {
                        label: 'Pechhulp caravan',
                        reference: 'pechhulp-caravan',
                        href: '/wegenwacht/caravan',
                    },
                    {
                        label: 'Pechhulp camper',
                        reference: 'pechhulp-camper',
                        href: '/wegenwacht/camper',
                    },
                    {
                        label: 'Pechhulp fiets',
                        reference: 'pechhulp-fiets',
                        href: '/wegenwacht/fiets',
                    },
                    {
                        label: 'Pechhulp motor',
                        reference: 'pechhulp-motor',
                        href: '/wegenwacht/motor',
                    },
                    {
                        label: 'Pechhulp bromfiets',
                        reference: 'pechhulp-bromfiets',
                        href: '/wegenwacht/bromfiets',
                    },
                    {
                        label: 'Pechhulp scootmobiel',
                        reference: 'pechhulp-scootmobiel',
                        href: '/wegenwacht/scootmobiel',
                    },
                ],
            ],
            group2: [
                [
                    {
                        label: 'Pechhulp Nederland',
                        reference: 'pechhulp-nederland',
                        href: '/wegenwacht/nederland',
                    },
                    {
                        label: 'Pechhulp Europa',
                        reference: 'pechhulp-europa',
                        href: '/wegenwacht/europa',
                    },
                ],
                [
                    {
                        label: 'Pechhulp jongeren',
                        reference: 'pechhulp-jongeren',
                        href: '/wegenwacht/jongeren',
                    },
                    {
                        label: 'Pechhulp partner',
                        reference: 'pechhulp-partner',
                        href: '/wegenwacht/partner',
                    },
                    {
                        label: 'Pechhulp zakelijk',
                        reference: 'pechhulp-zakelijk',
                        href: '/zakelijk/wegenwacht',
                    },
                ],
            ],
        },
    },
    {
        label: 'Verzekeringen',
        reference: 'verzekeringen',
        href: '/verzekeringen',
        subItems: {
            title: 'Verzekeringen',
            showAll: {
                label: 'Bekijk alles',
                href: '/verzekeringen',
            },
            group1: [
                [
                    {
                        label: 'Autoverzekering',
                        reference: 'autoverzekering',
                        href: '/verzekeringen/autoverzekering',
                    },
                    {
                        label: 'Caravanverzekering',
                        reference: 'caravanverzekering',
                        href: '/verzekeringen/caravanverzekering',
                    },
                    {
                        label: 'Fietsverzekering',
                        reference: 'fietsverzekering',
                        href: '/verzekeringen/fietsverzekering',
                    },
                    {
                        label: 'Scooterverzekering',
                        reference: 'scooterverzekering',
                        href: '/verzekeringen/scooterverzekering',
                    },
                ],
                [
                    {
                        label: 'Schade & Service',
                        reference: 'schade-en-service',
                        href: '/verzekeringen/service',
                    },
                ],
            ],
            group2: [
                [
                    {
                        label: 'Woonverzekering',
                        reference: 'woonverzekering',
                        href: '/verzekeringen/woonverzekering',
                    },
                    {
                        label: 'Inboedelverzekering',
                        reference: 'inboedelverzekering',
                        href: '/verzekeringen/inboedelverzekering',
                    },
                    {
                        label: 'Opstalverzekering',
                        reference: 'opstalverzekering',
                        href: '/verzekeringen/opstalverzekering',
                    },
                    {
                        label: 'Aansprakelijkheidsverzekering',
                        reference: 'aansprakelijkheidsverzekering',
                        href: '/aansprakelijkheidsverzekering',
                    },
                ],
                [
                    {
                        label: 'Annuleringsverzekering',
                        reference: 'annuleringsverzekering',
                        href: '/verzekeringen/annuleringsverzekering',
                    },
                ],
            ],
        },
    },
    {
        label: 'Energie',
        reference: 'energie',
        href: '/energie',
        subItems: {
            title: 'Energie',
            showAll: {
                label: 'Alles over energie en laden',
                href: '/energie',
            },
            group1: [
                [
                    {
                        label: 'Energiecontract',
                        reference: 'energiecontract',
                        href: '/energie/energiecontract',
                    },
                    {
                        label: 'Slimme energiemeter',
                        reference: 'slimme-energiemeter',
                        href: '/energie/slimme-energiemeter',
                    },
                    { label: 'Zonnepanelen', reference: 'zonnepanelen', href: '/energie/zonnepanelen' },
                    { label: 'Thuisbatterij', reference: 'thuisbatterij', href: '/energie/thuisbatterij' },
                ],
                [
                    { label: 'Laadpaal', reference: 'laadpaal', href: '/energie/laadpaal' },
                    {
                        label: 'Slimme laad-app',
                        reference: 'slimme-laad-app',
                        href: '/energie/slimme-laad-app',
                    },
                ],
            ],
        },
    },
    {
        label: 'Verkeer',
        reference: 'verkeer',
        href: '/verkeer',
        subItems: {
            title: 'Verkeer',
            showAll: {
                label: 'Alles over verkeer ',
                href: '/verkeer',
            },
            group1: [
                [
                    {
                        label: 'Verkeersinformatie',
                        reference: 'verkeersinformatie',
                        href: '/verkeer',
                    },
                    {
                        label: 'Wegwerkzaamheden',
                        reference: 'wegwerkzaamheden',
                        href: '/verkeer/wegwerkzaamheden',
                    },
                    {
                        label: 'Verkeersveiligheid',
                        reference: 'verkeersveiligheid',
                        href: '/verkeer/veiligheid/verkeersveiligheid',
                    },
                    {
                        label: 'Filelijst',
                        reference: 'filelijst',
                        href: '/verkeer/filelijst',
                    },
                ],
                [
                    {
                        label: 'Verkeer buitenland',
                        reference: 'verkeer-buitenland',
                        href: '/verkeer/buitenland',
                    },
                    {
                        label: 'Tol en vignette',
                        reference: 'tol-en-vignette',
                        href: '/verkeer/buitenland/toloverzicht',
                    },
                ],
            ],
            group2: [
                [
                    {
                        label: 'Routeplanner',
                        reference: 'routeplanner',
                        href: '/verkeer/routeplanner',
                    },
                    {
                        label: 'Onderweg app',
                        reference: 'onderweg app',
                        href: '/mobiel/onderweg-app',
                    },
                    {
                        label: 'Parkeren',
                        reference: 'parkeren',
                        href: '/verkeer/nederland/parkeren',
                    },
                ],
            ],
        },
    },
    {
        label: 'Auto',
        reference: 'auto',
        href: '/auto',
        subItems: {
            title: 'Auto',
            showAll: {
                label: 'Alles voor de auto',
                href: '/auto',
            },
            group1: [
                [
                    { label: 'Auto kopen', reference: 'auto-kopen', href: '/auto/kopen' },
                    {
                        label: 'Auto verkopen',
                        reference: 'auto-verkopen',
                        href: '/auto/verkopen',
                    },
                    {
                        label: 'Autowaarde berekenen',
                        reference: 'autowaarde-berekenen',
                        href: '/auto/autowaarde-berekenen',
                    },
                    {
                        label: 'Tests en specificaties',
                        reference: 'tests-en-specificaties',
                        href: '/auto/tests-en-specificaties',
                    },
                ],
                [
                    {
                        label: 'Elektrische auto’s',
                        reference: 'elektrische-auto’s',
                        href: '/auto/elektrisch-rijden',
                    },
                    {
                        label: 'Connected rijden',
                        reference: 'connected-rijden',
                        href: '/auto/connected-rijden',
                    },
                ],
            ],
            group2: [
                [
                    {
                        label: 'Auto huren',
                        reference: 'auto-huren',
                        href: '/auto/auto-huren',
                    },
                    {
                        label: 'Private Lease',
                        reference: 'private-lease',
                        href: '/auto/private-lease',
                    },
                ],
                [
                    {
                        label: 'Rijbewijs halen',
                        reference: 'rijbewijs halen',
                        href: '/auto/rijbewijs',
                    },
                    {
                        label: 'Autokosten',
                        reference: 'autokosten',
                        href: '/auto/autokosten',
                    },
                    { label: 'Tanken', reference: 'tanken', href: '/auto/brandstof' },
                ],
            ],
        },
    },
    {
        label: 'Fiets',
        reference: 'fiets',
        href: '/fiets',
        subItems: {
            title: 'Fiets',
            showAll: {
                label: 'Alles voor de fiets',
                href: '/fiets',
            },
            group1: [
                [
                    {
                        label: 'Elektrische fietsen',
                        reference: 'elektrische-fietsen',
                        href: '/fiets/elektrische-fietsen',
                    },
                    {
                        label: 'Soorten fietsen',
                        reference: 'soorten-fietsen',
                        href: '/fiets/soorten-fietsen',
                    },
                ],
                [
                    {
                        label: 'Fiets aankooptips',
                        reference: 'fiets-aankoptips',
                        href: '/fiets/fiets-aankoptips',
                    },
                    {
                        label: 'Fietslease',
                        reference: 'fietslease',
                        href: '/fiets/fietslease',
                    },
                    { label: 'Tests', reference: 'tests', href: '/fiets/test' },
                ],
            ],
            group2: [
                [
                    {
                        label: 'Accessoires-en-uitrusting',
                        reference: 'accessoires & uitrusting',
                        href: '/fiets/accessoires-uitrusting',
                    },
                    {
                        label: 'Onderhoud',
                        reference: 'onderhoud',
                        href: '/fiets/onderhoud',
                    },
                    {
                        label: 'Fietsaccu’s',
                        reference: 'fietsaccu’s',
                        href: '/fiets/fietsaccu',
                    },
                    {
                        label: 'Diefstal & veiligheid',
                        reference: 'diefstal-en-veiligheid',
                        href: '/fiets/diefstal-veiligheid',
                    },
                ],
            ],
        },
    },
    {
        label: 'Eropuit',
        reference: 'eropuit',
        href: '/eropuit',
        subItems: {
            title: 'Eropuit',
            showAll: {
                label: 'Alles over eropuit',
                href: '/eropuit',
            },
            group1: [
                [
                    {
                        label: 'Dagje uit',
                        reference: 'dagje-uit',
                        href: '/vrije-tijd/dagje-uit',
                    },
                    {
                        label: 'Weekendje weg',
                        reference: 'weekendje-weg',
                        href: '/vrije-tijd/weekendje-weg',
                    },
                ],
                [
                    {
                        label: 'Uitjes en tickets',
                        reference: 'uitjes-en-tickets',
                        href: '/landvananwb',
                    },
                    {
                        label: 'Fietsroutes',
                        reference: 'fietsroutes',
                        href: '/fietsroutes',
                    },
                    { label: 'Wandelen', reference: 'wandelen', href: '/wandelen' },
                ],
            ],
        },
    },
    {
        label: 'Vakantie',
        reference: 'vakantie',
        href: '/vakantie',
        subItems: {
            title: 'Vakantie',
            showAll: {
                label: 'Alles over vakantie',
                href: '/vakantie',
            },
            group1: [
                [
                    {
                        label: 'Inspiratie',
                        reference: 'inspiratie',
                        href: '/vakantie/ideeen',
                    },
                    {
                        label: 'Vakantie zoeken',
                        reference: 'vakantie-zoeken',
                        href: '/vakantie/zoeken',
                    },
                    {
                        label: 'Vakantie voorbereiden',
                        reference: 'vakantie-voorbereiden',
                        href: '/vakantie/reisvoorbereiding',
                    },
                ],
                [{ label: 'Kamperen', reference: 'kamperen', href: '/kamperen' }],
            ],
        },
    },
    {
        label: 'Webwinkel',
        reference: 'webwinkel',
        href: '//webwinkel.anwb.nl/webwinkel',
        subItems: {
            title: 'Webwinkel',
            showAll: {
                label: 'Alle categorieën',
                href: '//webwinkel.anwb.nl/webwinkel',
            },
            group1: [
                [
                    {
                        label: 'Aanbiedingen',
                        reference: 'aanbiedingen',
                        href: '//webwinkel.anwb.nl/webwinkel/ledenaanbiedingen.html',
                    },
                    {
                        label: 'Nieuwe collectie',
                        reference: 'nieuwe-collectie',
                        href: '//webwinkel.anwb.nl/webwinkel/nieuwe-collectie.html',
                    },
                ],
                [
                    {
                        label: 'Dames',
                        reference: 'dames',
                        href: '//webwinkel.anwb.nl/webwinkel/dames.html',
                        badge: 'sale',
                    },
                    {
                        label: 'Heren',
                        reference: 'heren',
                        href: '//webwinkel.anwb.nl/webwinkel/heren.html',
                        badge: 'sale',
                    },
                    {
                        label: 'Kleding',
                        reference: 'kleding',
                        href: '//webwinkel.anwb.nl/webwinkel/kleding.html',
                    },
                    {
                        label: 'Wandelen',
                        reference: 'wandelen',
                        href: '//webwinkel.anwb.nl/webwinkel/wandelen.html',
                    },
                ],
                [
                    {
                        label: 'Fietsen',
                        reference: 'fietsen',
                        href: '//webwinkel.anwb.nl/webwinkel/fietsen.html',
                    },
                    {
                        label: 'auto',
                        reference: 'auto',
                        href: '//webwinkel.anwb.nl/webwinkel/auto.html',
                    },
                ],
            ],
            group2: [
                [
                    {
                        label: 'Wintersport',
                        reference: 'wintersport',
                        href: '//webwinkel.anwb.nl/webwinkel/wintersport.html',
                    },
                    {
                        label: 'Reisartikelen',
                        reference: 'reisartikelen',
                        href: '//webwinkel.anwb.nl/webwinkel/reisartikelen.html',
                    },
                    {
                        label: 'Kamperen',
                        reference: 'kamperen',
                        href: '//webwinkel.anwb.nl/webwinkel/kamperen.html',
                    },
                ],
                [
                    {
                        label: 'Boeken & routekaarten',
                        reference: 'boeken-en-routekaarten',
                        href: '//webwinkel.anwb.nl/webwinkel/boeken-en-routekaarten.html',
                    },
                    {
                        label: 'Milieustickers & vignetten',
                        reference: 'milieustickers-en-vignetten',
                        href: '//webwinkel.anwb.nl/webwinkel/milieustickers-en-vignetten.html',
                    },
                ],
            ],
        },
    },
    {
        label: 'Lidmaatschap',
        reference: 'lidmaatschap',
        href: '/lidmaatschap',
        subItems: {
            title: 'Lidmaatschap',
            showAll: {
                label: 'Alles over ons lidmaatschap',
                href: '/lidmaatschap',
            },
            group1: [
                [
                    {
                        label: 'Lid worden',
                        reference: 'lid-worden',
                        href: '/lidmaatschap/lid-worden',
                    },
                    {
                        label: 'Ledenvoordeel',
                        reference: 'ledenvoordeel',
                        href: '/ledenvoordeel',
                    },
                    {
                        label: 'Lidmaatschap wijzigen',
                        reference: 'lidmaatschap wijzigen',
                        href: '/lidmaatschap/wijzigen',
                    },
                ],
                [
                    {
                        label: 'Maatschappelijke initiatieven',
                        reference: 'maatschappelijke-initiatieven',
                        href: '/lidmaatschap/maatschappelijk/anwb-betrokken',
                    },
                    { label: 'Kampioen', reference: 'kampioen', href: '/kampioen' },
                    {
                        label: 'Creditcards',
                        reference: 'creditcards',
                        href: '/creditcard',
                    },
                ],
            ],
        },
    },
    {
        label: 'Zakelijk',
        reference: 'zakelijk',
        href: '/zakelijk',
        subItems: {
            title: 'Zakelijk',
            showAll: {
                label: 'Alles over zakelijk',
                href: '/zakelijk',
            },
            group1: [
                [
                    {
                        label: 'Pechhulp zakelijk',
                        reference: 'pechhulp-zakelijk',
                        href: '/zakelijk/wegenwacht',
                    },
                    {
                        label: 'Mobiliteitskaart',
                        reference: 'mobiliteitskaart',
                        href: '/zakelijk/mobiliteitskaart',
                    },
                    {
                        label: 'Zakelijke lease',
                        reference: 'zakelijke-lease',
                        href: '/zakelijk/lease',
                    },
                ],
            ],
        },
    },
];
